export const APP_BAR_HEIGHT = '80px';
